export default __webpack_public_path__ + "static/media/corporate-customers.2e3890c1.svg";